import { Component, OnInit } from '@angular/core';
import { CommonGridService } from 'src/app/shared/services/common-grid.service';

@Component({
  selector: 'app-diary-test',
  templateUrl: './diary-test.component.html',
  styleUrls: ['./diary-test.component.scss']
})
export class DiaryTestComponent implements OnInit {
  public gridApiUrl:string = "/diary_user_responses"
  public type:string = "day"
  constructor(public cgService:CommonGridService) { }

  ngOnInit(): void {
    // this.cgService.initCommonGrid();
  }

}
